var map = {
	"./en-cd.json": 1247,
	"./en-gh.json": 1248,
	"./en-ke.json": 1249,
	"./en-mw.json": 1250,
	"./en-ng.json": 1251,
	"./en-ug.json": 1252,
	"./fr-cd.json": 1253,
	"./sw-ke.json": 1254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1246;